module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar rowID = '';\nvar primaryKey = 'id';\nif(resourceData.primaryKey) primaryKey = resourceData.primaryKey;\nif(resourceData.attributes && resourceData.attributes[primaryKey]) rowID = resourceData.attributes[primaryKey];\nvar additionalClasses = '';\nif(config.isHead) {\nadditionalClasses += ' isHead';\nif(config.isSortable){\nadditionalClasses += ' isSortable';\n}\n}\nelse if(config.isFilter){\nadditionalClasses += ' isFilter';\n}\nelse if(model.selectedRowIDs[rowID]){\nadditionalClasses += ' selected';\n}\n%>\n<tr class=\"<%- additionalClasses %>\" data-row-index=\"<%- resourceData.rowIndex %>\" data-row-id=\"<%- rowID %>\">\n<%\nif(Array.isArray(model.fields)){\nvar f;\nvar resources = {};\nvar column = './col';\nif(config.isHead)           column = './headCol';\nelse if(config.isFilter)    column = './filterCol';\nfor(f in model.fields){\nmodel.fields[f].colIndex = f;\nif(resourceData.attributes && model.fields[f].fieldCode && resourceData.attributes[model.fields[f].fieldCode] !== undefined){\nresources = resourceData.attributes[model.fields[f].fieldCode];\n}\nelse {\nresources = {}\n}\n%>\n<%- include(column, { formMapping: { modelFieldIndex: f }, model: model, resourceData: resources }); %>\n<%\n}\n}\n%>\n</tr>"
  , __filename = "node_modules/frontend-controller/baseComponents/table/row.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var rowID = '';
var primaryKey = 'id';
if(resourceData.primaryKey) primaryKey = resourceData.primaryKey;
if(resourceData.attributes && resourceData.attributes[primaryKey]) rowID = resourceData.attributes[primaryKey];
var additionalClasses = '';
if(config.isHead) {
additionalClasses += ' isHead';
if(config.isSortable){
additionalClasses += ' isSortable';
}
}
else if(config.isFilter){
additionalClasses += ' isFilter';
}
else if(model.selectedRowIDs[rowID]){
additionalClasses += ' selected';
}

    ; __line = 19
    ; __append("\n<tr class=\"")
    ; __line = 20
    ; __append( additionalClasses )
    ; __append("\" data-row-index=\"")
    ; __append( resourceData.rowIndex )
    ; __append("\" data-row-id=\"")
    ; __append( rowID )
    ; __append("\">\n")
    ; __line = 21
    ; 
if(Array.isArray(model.fields)){
var f;
var resources = {};
var column = './col';
if(config.isHead)           column = './headCol';
else if(config.isFilter)    column = './filterCol';
for(f in model.fields){
model.fields[f].colIndex = f;
if(resourceData.attributes && model.fields[f].fieldCode && resourceData.attributes[model.fields[f].fieldCode] !== undefined){
resources = resourceData.attributes[model.fields[f].fieldCode];
}
else {
resources = {}
}

    ; __line = 36
    ; __append("\n")
    ; __line = 37
    ; __append( include(column, { formMapping: { modelFieldIndex: f }, model: model, resourceData: resources }) )
    ; __append("\n")
    ; __line = 38
    ; 
}
}

    ; __line = 41
    ; __append("\n</tr>")
    ; __line = 42
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/table/row.ejs

}